export function Application(target: any) {
    /**
     * Application decorator
     */
}
